import { Link } from "react-router-dom";
import { ChevronRight, Mail, MapPin, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { useContent } from "../context/ContentContext";

export const Footer = () => {
  const { services, site } = useContent();
  return (
  <footer data-testid="site-footer" className="bg-[#3B3B38] text-[#D8D6CF]">
    <div className="mx-auto grid max-w-[1400px] gap-10 px-4 py-12 sm:grid-cols-3 sm:px-6">
      <div>
        <Logo light compact />
        <ul className="mt-4 space-y-2.5 text-sm">
          <li className="flex items-center gap-2.5">
            <MapPin className="h-4 w-4 shrink-0 text-cream" />
            {site.location}
          </li>
          <li>
            <a
              href={site.phoneHref}
              data-testid="footer-phone"
              className="flex items-center gap-2.5 transition-colors duration-200 hover:text-white"
            >
              <Phone className="h-4 w-4 shrink-0 text-cream" />
              {site.phoneDisplay}
            </a>
          </li>
          <li>
            <a
              href={`mailto:${site.email}`}
              data-testid="footer-email"
              className="flex items-center gap-2.5 transition-colors duration-200 hover:text-white"
            >
              <Mail className="h-4 w-4 shrink-0 text-cream" />
              {site.email}
            </a>
          </li>
        </ul>
      </div>

      <div>
        <h3 className="font-display text-lg font-bold uppercase tracking-wide text-white">
          Snelle links
        </h3>
        <ul className="mt-4 space-y-2 text-sm">
          {[
            { to: "/", label: "Home", testid: "footer-link-home" },
            { to: "/portfolio", label: "Portfolio", testid: "footer-link-portfolio" },
            { to: "/over-mij", label: "Over mij", testid: "footer-link-over-mij" },
            { to: "/contact", label: "Contact", testid: "footer-link-contact" },
            { to: "/privacy", label: "Privacy", testid: "footer-link-privacy" },
            { to: "/algemene-voorwaarden", label: "Algemene voorwaarden", testid: "footer-link-voorwaarden" },
            { to: "/garantie", label: "Garantie", testid: "footer-link-garantie" },
          ].map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                data-testid={l.testid}
                className="flex items-center gap-1.5 transition-colors duration-200 hover:text-white"
              >
                <ChevronRight className="h-3.5 w-3.5 text-cream" />
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h3 className="font-display text-lg font-bold uppercase tracking-wide text-white">
          Diensten
        </h3>
        <ul className="mt-4 space-y-2 text-sm">
          {services.map((s) => (
            <li key={s.slug}>
              <Link
                to={`/diensten/${s.slug}`}
                data-testid={`footer-dienst-${s.slug}`}
                className="flex items-center gap-1.5 transition-colors duration-200 hover:text-white"
              >
                <ChevronRight className="h-3.5 w-3.5 text-cream" />
                {s.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-[1400px] flex-col items-center justify-between gap-2 px-4 py-4 text-center text-xs text-[#9C9A93] sm:flex-row sm:px-6 sm:text-left">
        <p>© 2026 {site.name} · Opmeer</p>
        <span className="flex flex-wrap items-center gap-x-4 gap-y-1">
          {(site.kvk || site.btw) && (
            <span data-testid="footer-bedrijfsgegevens">
              {[site.kvk && `KvK ${site.kvk}`, site.btw && `Btw ${site.btw}`].filter(Boolean).join(" · ")}
            </span>
          )}
          <Link to="/privacy" data-testid="footer-privacy-link" className="transition-colors duration-200 hover:text-white">
            Privacyverklaring
          </Link>
          <Link to="/algemene-voorwaarden" data-testid="footer-voorwaarden-link" className="transition-colors duration-200 hover:text-white">
            Algemene voorwaarden
          </Link>
          <Link to="/garantie" data-testid="footer-garantie-link" className="transition-colors duration-200 hover:text-white">
            Garantie
          </Link>
        </span>
      </div>
    </div>
  </footer>
);
};
